// Generated from App.tsx for a single page build. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import WhatFamiliesAndProfessionalsSayPage from "../pages/WhatFamiliesAndProfessionalsSay/WhatFamiliesAndProfessionalsSay";
const __wvcRoutePaths = ["/WhatFamiliesAndProfessionalsSayPage"];
function AppRoutes() {
  const location = useLocation();
  return <Routes key={location.pathname}>
            
            
            
            
            
            
            
            
            <Route path={__wvcRoutePaths[0]} element={<WhatFamiliesAndProfessionalsSayPage />} />
            
            
            
            
            </Routes>;
}
function App() {
  return <>
            <div className="app">
                <AppRoutes />
            </div>
        </>;
}
export default App;
